/* TLC V16 — skin product pages: match the sticker page layout.
   - Moves the Afterpay block out of the old Live subtotal bar and puts it under the price (bar itself hidden).
   - Adds the small eyebrow above the title.
   - Shows prices without the AUD suffix, like the sticker page.
   - Custom skin page: turns the top bar into a title row (title, Afterpay, How it works). */
(function () {
  'use strict';

  function productInfo() {
    try {
      var el = document.querySelector('[data-tlc-finance-state]');
      return el ? JSON.parse(el.textContent).product || {} : {};
    } catch (e) { return {}; }
  }

  function kickerText(p, custom) {
    if (custom) return 'ZwapSkin · Custom';
    var hay = [p.title, p.handle].concat(p.tags || []).join(' ').toLowerCase();
    if (/keyboard/.test(hay)) return 'ZwapSkin · Magic Keyboard';
    if (/ipad/.test(hay)) return 'ZwapSkin · iPad';
    if (/boox/.test(hay)) return 'ZwapSkin · Boox';
    if (/kindle|kobo|ereader|e-reader/.test(hay)) return 'ZwapSkin · E-reader';
    return 'ZwapSkin';
  }

  function makeKicker(text, tag) {
    var k = document.createElement(tag || 'p');
    k.className = 'tlc-v16-kicker';
    k.textContent = text;
    return k;
  }

  function stripAud(root) {
    root.querySelectorAll('.price-item').forEach(function (el) {
      if (/\sAUD\s*$/.test(el.textContent)) el.textContent = el.textContent.replace(/\s*AUD\s*$/, '');
    });
  }

  function regular(main, p) {
    var info = main.querySelector('.product__info-container');
    if (!info) return;
    var title = info.querySelector(':scope > .product__text.subtitle');
    if (title && !info.querySelector('.tlc-v16-kicker')) title.before(makeKicker(kickerText(p, false)));

    var priceEl = info.querySelector('.price');
    var priceBlock = priceEl ? priceEl.closest('.product__info-container > *') : null;
    if (priceBlock) {
      stripAud(priceBlock);
      if (!priceBlock.dataset.tlcV16Obs && window.MutationObserver) {
        priceBlock.dataset.tlcV16Obs = '1';
        new MutationObserver(function () { stripAud(priceBlock); })
          .observe(priceBlock, { childList: true, subtree: true, characterData: true });
      }
    }

    // Finish cards: show this skin's design (main photo) under each finish texture
    if (!main.dataset.tlcV16Design) {
      var src = p.featured_image || (p.images && p.images[0]);
      if (src) {
        if (src.indexOf('//') === 0) src = 'https:' + src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        main.style.setProperty('--tlc-v16-design', 'url(' + JSON.stringify(src) + ')');
        main.dataset.tlcV16Design = '1';
      }
    }

    // Breadcrumb above the gallery, like the sticker page
    var productBox = main.querySelector(':scope > .product');
    if (productBox && !main.querySelector('.tlc-v16-crumbs') && p.title) {
      var nav = document.createElement('nav');
      nav.className = 'tlc-v16-crumbs';
      nav.setAttribute('aria-label', 'Breadcrumb');
      var home = document.createElement('a');
      home.href = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      home.textContent = 'Home';
      var cur = document.createElement('span');
      cur.setAttribute('aria-current', 'page');
      cur.textContent = ' ' + p.title;
      nav.append(home, ' /', cur);
      productBox.before(nav);
    }

    // Quantity and Add to cart on one row, like the sticker page
    var qty = info.querySelector('.product-form__quantity');
    var buttons = main.querySelector('.product-form__buttons');
    if (qty && buttons && !buttons.classList.contains('tlc-v16-buyrow')) {
      buttons.classList.add('tlc-v16-buyrow');
      buttons.prepend(qty);
    }

    var bar = main.querySelector('[data-tlc-v10a-live-summary]');
    if (bar && priceBlock && !bar.classList.contains('tlc-v16-pay')) {
      bar.classList.add('tlc-v16-pay');
      bar.removeAttribute('aria-live');
      priceBlock.after(bar);
    }
  }

  // Custom page: lift the discount bar out of the studio box so it sits on the page like the e-reader bar
  function liftBar(main) {
    var w = main.querySelector('.tlc-savings-widget');
    var box = w && w.parentElement;
    if (!w || !box || w.classList.contains('tlc-v16-out') || !box.classList.contains('zss-studio-box')) return;
    w.classList.add('tlc-v16-out');
    box.before(w);
  }

  function custom(main, head) {
    if (head.classList.contains('tlc-v16-head')) return;
    head.classList.add('tlc-v16-head');
    var label = head.querySelector('.tlc-v10a-live-summary__label');
    if (label && !label.querySelector('.tlc-v16-kicker')) label.prepend(makeKicker(kickerText({}, true), 'span'));
  }

  function run() {
    var main = document.querySelector('[id^=MainProduct-]');
    if (!main) return false;
    var p = productInfo();
    var head = main.querySelector('[data-tlc-custom-summary]');
    var studio = main.querySelector('.zss-studio-box');
    if (head || studio) {
      if (head) custom(main, head);
      liftBar(main);
      return !!main.querySelector('.tlc-v16-out') && !!main.querySelector('.tlc-v16-head');
    }
    if (main.classList.contains('tlc-skin-product')) {
      regular(main, p);
      return !!main.querySelector('.tlc-v16-pay');
    }
    return false;
  }

  function boot() {
    if (run()) return;
    // The skin scripts (and the custom studio) build their bars after load, sometimes several seconds later.
    // Watch the page until they exist, then stop.
    if (!window.MutationObserver) return;
    var queued = false;
    var obs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (run()) obs.disconnect();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
